/**
 * Texts for Webinars page
 * 
 * VIDEO URL FORMATS SUPPORTED:
 * 1. YouTube URLs:
 *    - https://www.youtube.com/watch?v=VIDEO_ID
 *    - https://youtu.be/VIDEO_ID
 *    - https://www.youtube.com/embed/VIDEO_ID
 * 
 * 2. Local video files:
 *    - /video/filename.mp4
 *    - Relative or absolute paths to MP4 files
 * 
 * Simply edit the 'videoUrl' field in each video object below.
 * The system automatically detects YouTube links and displays them accordingly.
 */
export const webinarsPageText = {
    title: 'Webinars - CamAPS FX',
    titleMeta: 'CamAPS FX Webinars - Educational video sessions',
    descriptionMeta: 'Watch educational webinars to learn more about using the CamAPS FX app.',
    keywords:
        'camaps fx webinars, camaps tutorials, diabetes app tutorials, insulin pump webinars, cgm webinars, video guides',
    localeMeta: 'da_dk',

    mainHeader: 'Webinarer',
    mainSubHeader: 'Deltag i vores live-webinarer og optagne sessioner.',
    webinarsDisclaimer: 'Alle webinarer udgives på engelsk',

    altHelp: 'Hjælp',
    altInfo: 'Info',
    altAppStore: 'Download i App Store',
    altGooglePlay: 'Hent den på Google Play',
    ariaGoToSlide: 'Gå til slide {n}',
    ariaNextSlide: 'Næste slide',
    ariaPrevSlide: 'Forrige slide',
    videoNotSupportedText: 'Din browser understøtter ikke video-tagget.',
    virtualModeTooltipText: 'Virtuel tilstand giver dig mulighed for at afprøve appen uden at være forbundet til en rigtig insulinpumpe og CGM-sensor.',
    closeButtonText: 'Luk',
    filterAll: 'Alle',
    filterYpsoPump: 'YpsoPump',
    filterDana: 'Dana',
    sortNewest: 'Nyeste',
    sortOldest: 'Ældste',
    sortAZ: 'A-Z',
    sortPopular: 'Mest populære',
    // Getting Started Section
    gettingStartedHeader: 'Klar til at komme i gang?',
    step1Title: '<strong>Trin 1:</strong> Download appen',
    step2Title: '<strong>Trin 2:</strong> Opret en konto',
    step3Title: '<strong>Trin 3:</strong> Begynd den væsentlige træning i appen',
    step4Title: '<strong>Trin 4:</strong> Par din valgte pumpe og CGM (med godkendelse fra dit sundhedsteam) eller udforsk appen med <strong>Virtuel tilstand</strong>',
    
    // Support Section
    supportSectionTitle: 'Har du brug for mere hjælp?',
    supportSectionText: 'Vores supportteam er her for at hjælpe dig med eventuelle spørgsmål.',
    supportButtonText: 'KONTAKT SUPPORT',

    videos: [
        // {
        //     id: 1,
        //     title: 'Introduction to CamAPS FX',
        //     description: 'Learn the basics of CamAPS FX and how it works.',
        //     date: '15 Dec 2024',
        //     duration: '5:24',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 5420
        // },
        // {
        //     id: 2,
        //     title: 'Advanced Pump Settings',
        //     description: 'Explore advanced pump configuration options.',
        //     date: '10 Dec 2024',
        //     duration: '7:15',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 8950
        // },
        // {
        //     id: 3,
        //     title: 'Understanding CGM Integration',
        //     description: 'Learn how to integrate and use CGM data effectively.',
        //     date: '5 Dec 2024',
        //     duration: '4:33',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 12340
        // },
        // {
        //     id: 4,
        //     title: 'Pump Troubleshooting Guide',
        //     description: 'Common issues and solutions for pump connectivity.',
        //     date: '1 Dec 2024',
        //     duration: '6:48',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'dana',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 3210
        // },
        // {
        //     id: 5,
        //     title: 'Meal Planning with CamAPS FX',
        //     description: 'Best practices for meal-time insulin delivery.',
        //     date: '28 Nov 2024',
        //     duration: '5:12',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 6780
        // },
        // {
        //     id: 6,
        //     title: 'Night Time Management',
        //     description: 'Optimize your settings for better overnight control.',
        //     date: '25 Nov 2024',
        //     duration: '8:05',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 9450
        // },
        // {
        //     id: 7,
        //     title: 'Exercise and Activity Mode',
        //     description: 'Configure settings for physical activity.',
        //     date: '20 Nov 2024',
        //     duration: '3:27',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 4120
        // },
        // {
        //     id: 8,
        //     title: 'Data Analysis and Reports',
        //     description: 'How to interpret and use your glucose data effectively.',
        //     date: '15 Nov 2024',
        //     duration: '4:55',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'dana',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 7230
        // },
        // {
        //     id: 9,
        //     title: 'Safety Features Overview',
        //     description: 'Understanding safety alarms and alerts in CamAPS FX.',
        //     date: '10 Nov 2024',
        //     duration: '6:18',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 10560
        // },
        // {
        //     id: 10,
        //     title: 'Customization Tips',
        //     description: 'Personalize your CamAPS FX experience.',
        //     date: '5 Nov 2024',
        //     duration: '5:41',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 5890
        // },
        // {
        //     id: 11,
        //     title: 'Bluetooth Connectivity',
        //     description: 'Troubleshooting connection issues with your devices.',
        //     date: '1 Nov 2024',
        //     duration: '7:52',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'dana',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 8120
        // },
        // {
        //     id: 12,
        //     title: 'Getting the Most from CamAPS FX',
        //     description: 'Advanced tips and tricks for optimal usage.',
        //     date: '28 Oct 2024',
        //     duration: '6:03',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg',
        //     views: 11230
        // },
        {
            id: 12,
            title: 'Roman Hovorka wins EASD 2023 Award',
            description: 'Roman Hovorka wins EASD 2023 Award',
            date: '27 Sep 2023',
            duration: '9:57',
            category: 'ypso',
            videoUrl: 'https://www.youtube.com/watch?v=4PPuVNGmxFU',
            views: 12900,
        },
        {
            id: 13,
            title: 'Hybrid Closed-Loop (HCL) Therapy for People with Type 1 Diabetes who are Pregnant - NHS England',
            description: 'Hybrid Closed-Loop (HCL) Therapy for People with Type 1 Diabetes who are Pregnant - NHS England',
            date: '8 Oct 2024',
            duration: '1:30:00',
            category: 'ypso',
            videoUrl: 'https://youtu.be/wsdIWw5XPeE',
            views: 12800,
        },
        {
            id: 14,
            title: 'Managing Pregnancy using the CamAPS FX HCL system Webinar',
            description: 'Managing Pregnancy using the CamAPS FX HCL system Webinar',
            date: '20 Jan 2021',
            duration: '1:27:12',
            category: 'ypso',
            videoUrl: 'https://youtu.be/_y15xt6zUao',
            views: 12700,
        },
        {
            id: 15,
            title: 'CamAPS FX catch up with Helen Murphy, Professor of Medicine (Diabetes and Antenatal Care), UK',
            description: 'CamAPS FX catch up with Helen Murphy, Professor of Medicine (Diabetes and Antenatal Care), UK',
            date: '22 Apr 2026',
            duration: '7:24',
            category: 'ypso',
            thumbnail: '/images/helen.jpg',
            videoUrl: 'https://youtu.be/arJbSlkJ4HU',
            views: 14500,
        },
        {
            id: 16,
            title: 'Introducing CamAPS Liberty',
            description: 'Introducing CamAPS Liberty',
            date: '28 Jul 2026',
            duration: '14:42',
            category: 'ypso',
            thumbnail: '/images/introducing-camaps-liberty.png',
            videoUrl: 'https://youtu.be/K7_j-Sk5Fas',
            views: 14600,
        },
        {
            id: 17,
            title: 'CamAPS Liberty: Getting started',
            description: 'CamAPS Liberty: Getting started',
            date: '15 Sep 2026',
            duration: '31:50',
            category: 'ypso',
            videoUrl: 'https://youtu.be/px9QSOhy544',
            views: 14700,
        }
    ]
};

